module.exports = __webpack_public_path__ + "static/media/smart-store-logo-easy.e8980541.svg";